/** Central location for texture format choices. Storage-texture compatibility matters. */

export const formats = {
  /** Heightmap, water, sediment — single-channel storage-friendly float. */
  heightStorage: 'r32float' as GPUTextureFormat,
  /** Erosion flux: per-cell L/R/T/B outflow rates. */
  fluxStorage: 'rgba32float' as GPUTextureFormat,
  /** Biome IDs (0..7). r32uint because r8uint is not a core-feature storage format. */
  biomeStorage: 'r32uint' as GPUTextureFormat,
  /** JFA seed/parent IDs. */
  jfaStorage: 'r32uint' as GPUTextureFormat,
  /** Road mask 0..1. r32float because r8unorm storage requires an optional feature. */
  roadStorage: 'r32float' as GPUTextureFormat,

  /** HDR scene color (post pass tonemaps to swapchain). */
  hdrColor: 'rgba16float' as GPUTextureFormat,
  /** Depth used for both shadow pass and main pass. */
  depth: 'depth32float' as GPUTextureFormat,
} as const;

export type Formats = typeof formats;
